import React from 'react';
import RadioGroup from '../../../reusable/Form/RadioGroup';
import {FormattedMessage, injectIntl} from 'react-intl';
import Modal from "../../../reusable/Modal/Modal.index";
import {ENTITIES_DOWNLOAD_OPTIONS} from "../../../constants";
import PropTypes from "prop-types";

export class EntitiesDownloadModal extends React.Component {

    static propTypes = {
        hasAllItemsSelected: PropTypes.bool,
        secondaryAction: PropTypes.func,
        primaryAction: PropTypes.func
    };

    static defaultProps = {
        hasAllItemsSelected: true
    };

    state = {
        userSelectionType: ENTITIES_DOWNLOAD_OPTIONS.ALL_ENTITIES,
    };

    setUserSelectionType = (event) => {
        this.setState({
            userSelectionType: event.target.value
        });
    };

    componentDidMount() {
        let selectionType = this.props.hasAllItemsSelected
            ? ENTITIES_DOWNLOAD_OPTIONS.ALL_ENTITIES
            : ENTITIES_DOWNLOAD_OPTIONS.SELECTED_ENTITIES;

        this.setState({
            userSelectionType: selectionType
        })
    }

    radioOptions = [
        {
            value: ENTITIES_DOWNLOAD_OPTIONS.ALL_ENTITIES,
            label: <FormattedMessage id="Entities_Download_UIText_modalOptions.all"/>
        },
        {
            value: ENTITIES_DOWNLOAD_OPTIONS.SELECTED_ENTITIES,
            label: <FormattedMessage id="Entities_Download_UIText_modalOptions.selected"/>,
        }
    ];

    render() {
        return (
            <div id='ModalDownloadEntities' className='entities-download-modal'>

                <Modal closeButtonHandler={this.props.secondaryAction}
                       buttons={
                           [
                               {
                                   text: <FormattedMessage
                                       id={"UserAudit_Download_UIText_modalActions.download"}/>,
                                   click: () => this.props.primaryAction(this.state.userSelectionType),
                                   primary: true
                               },
                               {
                                   text: <FormattedMessage
                                       id={"General_CoreFunctionality_UIText_general.cancel"}/>,
                                   click: this.props.secondaryAction,
                                   tabIndex: 1
                               }
                           ]
                       }>

                    <div>
                        <h2 className="modal-header">
                            <FormattedMessage id={"Entities_Download_UIText_modalTitle"}/>
                        </h2>
                        <div className='modal-body-container'>
                            <RadioGroup value={this.state.userSelectionType}
                                        fieldId={"users-selector"}
                                        onChange={this.setUserSelectionType}
                                        options={this.radioOptions}/>
                        </div>
                    </div>

                </Modal>

            </div>
        )
    }
}

export default injectIntl(EntitiesDownloadModal);


// WEBPACK FOOTER //
// ./src/scripts/pages/Entities/components/EntitiesDownloadModal.jsx